import {
  paramOrNul, getClientPlatform, getData, calculateDifference
} from '../../common/config/utils';
import { getCurrentLocalization } from '../config/i18n';
import env from '../config/variables';
import { getDateFromServerUTC } from '../config/util';

const { BACKEND_VERSION } = env;

const getCurrentGlobalSale = ({ mixpanel, promotionData }) => {
  if (!promotionData) return null;
  const { promotionTitle, promotionStopAt, promotionStartAt } = promotionData;
  let currentGlobalSale = null;
  const dateNow = new Date();
  if (dateNow >= new Date(promotionStartAt) && dateNow <= new Date(promotionStopAt)) {
    if (promotionTitle) {
      currentGlobalSale = promotionTitle;
    }
  }
  if (mixpanel && mixpanel.get_property('current global sale') && !currentGlobalSale) {
    mixpanel.unregister('current global sale');
  }
  return currentGlobalSale;
};

export const getBaseSuperProperties = ({ user, mixpanel }) => {
  const { dynamicConfig } = window.store.getState().application;
  const date = getDateFromServerUTC(dynamicConfig?.utc);
  let baseSuperProperties = {
    'day of week': getData({ date, type: 'day' }),
    'hour of day': getData({ date, type: 'hours' }),
    year: getData({ date, type: 'year' }),
    month: getData({ date, type: 'month' }),
    'year-month': `${ getData({ date, type: 'year' }) }-${ getData({ date, type: 'month' }) }`,
    language: getCurrentLocalization(),
    platform: getClientPlatform(),
    ...paramOrNul('current global sale', getCurrentGlobalSale({ mixpanel, promotionData: dynamicConfig?.promotionData }))
  };

  if (user && Object.keys(user).length !== 0) {
    const baseUserSuperProperties = {
      'user type': 'client',
      'credit balance': parseFloat(user.clientAvailableCredit),
      'total purchased': parseFloat(user.totalPurchased),
      'total purchase fees paid': parseFloat(user.totalPurchaseFeesPaid),
      'purchases count': user.purchasesCount,
      ...paramOrNul('last purchase date', user.lastPurchaseDate),
      'days since last purchase': calculateDifference({ date1: date, date2: user.lastPurchaseDate, type: 'days' }) || 0,
      'login type': user.loginType?.replaceAll('_', ' '),
      ...paramOrNul('gender', user.gender),
      ...paramOrNul('age', calculateDifference({ date1: date, date2: user.dateOfBirth, type: 'years' })),
      ...paramOrNul('install date', user.installDate),
      'days from install': calculateDifference({ date1: date, date2: user.installDate, type: 'days' }) || 0,
      ...paramOrNul('signup date', user.createdAt),
      'days from signup': calculateDifference({ date1: date, date2: user.createdAt, type: 'days' }) || 0,
      'backend version': parseInt(BACKEND_VERSION, 10),
      ...paramOrNul('paypal total charged', user.paypalTotalCharged),
      ...paramOrNul('credit card total charged', user.creditCardTotalCharged),
      'pay as you go allowed': user.analytics?.payAsYouGoAllowed
    };
    baseSuperProperties = { ...baseSuperProperties, ...baseUserSuperProperties };
  } else {
    baseSuperProperties['user type'] = 'anonymous';
  }
  return baseSuperProperties;
};

export const getBaseProfileProperties = () => {
  const baseProfileProperties = {
    'last seen platform': getClientPlatform(),
    'Last Seen Backend Version': parseInt(BACKEND_VERSION, 10)
  };
  return baseProfileProperties;
};

export const getDaySinceProps = (props) => {
  const { dynamicConfig } = window.store.getState().application;
  const date = getDateFromServerUTC(dynamicConfig?.utc);
  return {
    ...paramOrNul('days since signup', calculateDifference({ date1: date, date2: props?.['signup date'], type: 'days' })),
    ...paramOrNul('days since first purchase', calculateDifference({ date1: date, date2: props?.['first purchase date'], type: 'days' })),
    ...paramOrNul('days since last live session', calculateDifference({ date1: date, date2: props?.['last live session date'], type: 'days' })),
    ...paramOrNul('days since fbm', calculateDifference({ date1: date, date2: props?.['fbm date'], type: 'days' })),
    ...paramOrNul('days since first visit', calculateDifference({ date1: date, date2: props?.['first visit date'], type: 'days' }))
  };
};
